<app-bottom-sheet-mobile-header (closeEvent)="close()" />
<div class="mx-6 mb-3 flex flex-col">
  <button (click)="close('csv')" class="text-left font-normal text-base text-ui-dark h-10">
    Export to CSV
  </button>
  <button (click)="close('json')" class="text-left font-normal text-base text-ui-dark h-10">
    Export to JSON
  </button>
</div>
